import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  CompanyDto,
  CompanyIdentifierDto,
  CompanySimpleDto,
  PolicyContractCoInsurerCompanyDto,
  PolicyContractVersionDto,
  PolicyInquiryPrimeDebtorCompanyDto,
  PolicyInquiryVersionDto,
  RelatedObject,
  RouterService,
} from '../../../../../bonding_shared';
import {CompanyIdentifierType, CompanyType} from '../../../../../bonding_shared/model/dictionary-ids';
import {ListEmitters} from '../../../../../bonding_shared/components/details-view/list-emitters';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'common-prime-debtors-section',
  templateUrl: './common-prime-debtors-section.component.pug',
})
export class CommonPrimeDebtorsSectionComponent extends ListEmitters {
  readonly CompanyType = CompanyType;

  constructor(public router: RouterService) {
    super();
    this.selectorNameList = [RelatedObject.PRIME_DEBTORS];
    this.initializeSelectorEmitters(true);
  }

  @Input() titleKey: string;
  @Input() selectorLabelKey: string;
  @Input() readonly: boolean;
  @Input() showErrors: boolean;
  @Input() parentForm: UntypedFormGroup;
  @Input() parent: PolicyContractVersionDto | PolicyInquiryVersionDto;

  @Output() addPrimeDebtors = new EventEmitter<CompanySimpleDto>();

  addDebtors(company: CompanySimpleDto) {
    this.addPrimeDebtors.emit(company);
  }

  toCompanyPreview(primeDebtors: PolicyContractCoInsurerCompanyDto | PolicyInquiryPrimeDebtorCompanyDto) {
    this.router.toCompanyPreview(primeDebtors.company.id);
  }

  getMdgNumber(company: CompanyDto): string {
    if (!company?.identifiers?.length) {
      return null;
    }
    const identifierObj = company?.identifiers.find(
      (entity: CompanyIdentifierDto) => entity?.type.id === CompanyIdentifierType.MDG_NUMBER
    );
    return identifierObj?.identifier ?? null;
  }
}
